import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { getIpoHypotheticalInvestment, getIpoMetadata } from '@api/ipo';
import { IpoHypotheticalInvestment, IpoMetadata } from 'types/ipo';
import big from 'big.js';
import { getServiceLevelPrincipal } from '@api/investment-entity';
import { ServiceLevelPrincipal } from 'types/portfolio';
import store from '..';

@Module({
	dynamic: true,
	namespaced: true,
	name: 'ipo',
	store
})
class IpoModule extends VuexModule {
	ipoMetadata: IpoMetadata | null = null;
	serviceLevelPrincipal: ServiceLevelPrincipal | null = null;
	ipoHypotheticalInvestment: IpoHypotheticalInvestment | null = null;

	get isLeadUpEligible(): boolean {
		return this.ipoMetadata?.ipoEligibility.ipoPhaseAndEligibilityEnum === 'LEAD_UP_ELIGIBLE';
	}

	get hasPendingInvestmentInLeadUp(): boolean {
		return (
			this.isLeadUpEligible &&
			this.serviceLevelPrincipal !== null &&
			big(this.serviceLevelPrincipal.pendingPrincipal).gt(0)
		);
	}

	@Action({ rawError: true })
	public async fetchAndStoreMetadata(): Promise<void> {
		const ipoMetadata = await getIpoMetadata();
		this.UPDATE_IPO_METADATA(ipoMetadata);
	}

	@Action({ rawError: true })
	public async fetchAndStoreServiceLevelPrincipal(): Promise<void> {
		const serviceLevelPrincipal = await getServiceLevelPrincipal();
		this.UPDATE_SERVICE_LEVEL_PRINCIPAL(serviceLevelPrincipal);

		if (this.hasPendingInvestmentInLeadUp || this.isLeadUpEligible) {
			await this.fetchAndStoreIpoHypotheticalInvestment(serviceLevelPrincipal.pendingPrincipal);
		}
	}

	@Action({ rawError: true })
	public async fetchAndStoreIpoHypotheticalInvestment(pendingPrincipal: string): Promise<void> {
		const ipoHypotheticalInvestment = await getIpoHypotheticalInvestment(pendingPrincipal);
		this.UPDATE_IPO_HYPOTHETICAL_INVESTMENT(ipoHypotheticalInvestment);
	}

	@Mutation
	public UPDATE_IPO_METADATA(ipoMetadata: IpoMetadata): void {
		this.ipoMetadata = ipoMetadata;
	}

	@Mutation
	public UPDATE_SERVICE_LEVEL_PRINCIPAL(serviceLevelPrincipal: ServiceLevelPrincipal): void {
		this.serviceLevelPrincipal = serviceLevelPrincipal;
	}

	@Mutation
	public UPDATE_IPO_HYPOTHETICAL_INVESTMENT(ipoHypotheticalInvestment: IpoHypotheticalInvestment | null): void {
		this.ipoHypotheticalInvestment = ipoHypotheticalInvestment;
	}
}

export const ipo = getModule(IpoModule);
